import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';   // ✅ IMPORTANT
import { OrderCreationService } from '../../../../Services/order-creation.service';

@Component({
  selector: 'app-assign-history',
  standalone: true,               // ✅ CONFIRM standalone
  imports: [CommonModule],        // ✅ THIS FIXES ALL ERRORS
  templateUrl: './assign-history.component.html',
  styleUrls: ['./assign-history.component.css']
})
export class AssignHistoryComponent implements OnInit {

  orderId!: number;
  isLoading = false;
  historyList: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderCreationService
  ) {}

  ngOnInit(): void {
    this.orderId = Number(this.route.snapshot.paramMap.get('id'));
    this.fetchAssignHistory();
  }

  fetchAssignHistory(): void {
    this.isLoading = true;

    this.orderService.getOrderAssignHistory(this.orderId).subscribe({
      next: (res: any) => {
        this.historyList = res?.data ?? [];
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Assign history fetch failed', err);
        this.isLoading = false;
      }
    });
  }
}
